import { UNLIMITED_QUOTA_SENTINEL } from '@/lib/quota/deriveQuotaPressure';

/**
 * Clipper-mode "clips" are the library export cap the sidebar already shows.
 */
export function resolveClipperMonthlyClipLimit(
  maxLibraryExports: number | null | undefined,
): number | 'unlimited' {
  const max = Number(maxLibraryExports ?? 0);
  if (!Number.isFinite(max) || max <= 0) return 0;
  if (max >= UNLIMITED_QUOTA_SENTINEL) return 'unlimited';
  return Math.floor(max);
}
